import React, { useCallback, useEffect, useState } from 'react'
import { useWindowSize, useWindowScroll } from 'react-use'
import { AbDonateButton } from 'ppp'
import { StickyPhoneProps } from './types'
import { SharingGridButton } from 'shared'

export const AbStickyPhone = (
  { project, status }: StickyPhoneProps,
  { shareUrl }: { shareUrl: string }
): JSX.Element => {
  const [visible, setVisible] = useState(true)
  const [left, setLeft] = useState(0)

  const handleScroll = useCallback(() => {
    const unTriggerDistance = (document.querySelector('footer')?.getBoundingClientRect().top ?? 0) - window.innerHeight
    setVisible(unTriggerDistance >= 0)
  }, [])

  const handleResize = useCallback(() => {
    let bodyLeft = document.querySelector('body')?.getBoundingClientRect().left ?? 0
    if (bodyLeft < 0) bodyLeft = 0
    setLeft(bodyLeft)
  }, [])

  const { y } = useWindowScroll()
  useEffect(() => {
    y === 0 || handleScroll()
  }, [y, handleScroll])
  const { width, height } = useWindowSize()
  useEffect(() => {
    width && handleResize()
  }, [width, height, handleResize])

  return (
    <div className="ab-phone-sticky-wrapper" style={{ opacity: visible ? 1 : 0, left: left }}>
      <SharingGridButton
        shareUrl={shareUrl}
        gaLabel="ppp_stats"
        platforms={['email', 'facebook', 'twitter', 'link', 'whatsapp', 'messenger']}
        modalHeader={I18n.t('projects.show.stats.share_modal_headline')}
        buttonLabel={I18n.t('projects.show.stats.share_button_label')}
        className="btn-large flex-1"
      />
      <AbDonateButton
        className="btn-large ml-4"
        project={project}
        status={status}
        gaAction="click donate_button__sticky"
      />
    </div>
  )
}
